module.exports = __webpack_public_path__ + "media/stylesheets/images/mattrz_lp/logos/logo-03-5f495e1b12eb5acd65a9256dd76caf79.png";